import axios from "axios";
import { API_URL } from "../../constants";
import { select } from "../company-select/company-select.service";
import {
  getRouteCompanyId,
  isSelectedCompanyProblem,
} from "../auth/access-lost";

// These endpoints have no company in the path: the server uses the company stored on
// the session, which may be an old one (or a company the person was dismissed from).
// When it says so, store the company the person has open and ask once more.
async function requestForOpenCompany(sendRequest) {
  try {
    return await sendRequest();
  } catch (error) {
    const openCompanyId = getRouteCompanyId(window.location.pathname);
    if (!isSelectedCompanyProblem(error) || !openCompanyId) throw error;

    await select({ companyToSelect: openCompanyId });
    return sendRequest();
  }
}

export const fetch = (filtersValue) =>
  requestForOpenCompany(() => {
    const url = `${API_URL}/vats/fetch`;
    return axios.post(url, { filtersValue }).then((response) => response.data);
  });

export const post = (data) =>
  requestForOpenCompany(() => {
    const url = `${API_URL}/vats/post`;
    return axios.post(url, data).then((response) => response.data);
  });

export const fetchById = (vatId) =>
  requestForOpenCompany(() => {
    const url = `${API_URL}/vats/fetchById/${vatId}`;
    return axios.get(url).then((response) => response.data);
  });
